import { render, staticRenderFns } from "./OtherRequests.vue?vue&type=template&id=7665dcb7"
import script from "./OtherRequests.vue?vue&type=script&lang=js"
export * from "./OtherRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports